import { Box, Flex, Select, Switch, Text } from '@chakra-ui/react'
import React from 'react'
import {
  type ClinicClientNotificationPreferencesDtoAppointmentsItemsItem,
  type ClinicClientNotificationPreferencesDtoAppointmentsItemsItemRemindBeforeUnit,
  ClinicClientNotificationPreferencesDtoAppointmentsItemsItemType
} from '~/clinician-api/models'

const FIRST_REMINDER_OPTIONS = [
  { unit: 'weeks', value: 1 },
  { unit: 'weeks', value: 2 },
  { unit: 'days', value: 3 },
  { unit: 'days', value: 2 }
]

const SECOND_REMINDER_OPTIONS = [
  { unit: 'days', value: 1 },
  { unit: 'days', value: 2 },
  { unit: 'hours', value: 12 }
]

const THIRD_REMINDER_OPTIONS = [
  { unit: 'hours', value: 4 },
  { unit: 'hours', value: 2 },
  { unit: 'hours', value: 1 },
  { unit: 'minutes', value: 30 }
]

const getReminderInfo = (
  type: ClinicClientNotificationPreferencesDtoAppointmentsItemsItem['type']
) => {
  if (
    type ===
    ClinicClientNotificationPreferencesDtoAppointmentsItemsItemType.AppointmentsFirstReminder
  ) {
    return {
      label: 'First Reminder',
      options: FIRST_REMINDER_OPTIONS
    }
  }
  if (
    type ===
    ClinicClientNotificationPreferencesDtoAppointmentsItemsItemType.AppointmentsSecondReminder
  ) {
    return {
      label: 'Second Reminder',
      options: SECOND_REMINDER_OPTIONS
    }
  }
  return {
    label: 'Third Reminder',
    options: THIRD_REMINDER_OPTIONS
  }
}

interface AppointmentReminderItemProps {
  item: ClinicClientNotificationPreferencesDtoAppointmentsItemsItem
  onUpdate: (
    value: Partial<ClinicClientNotificationPreferencesDtoAppointmentsItemsItem>
  ) => Promise<void>
}

export const AppointmentReminderItem: React.FC<
  AppointmentReminderItemProps
> = ({ item, onUpdate }) => {
  const { label, options } = getReminderInfo(item.type)

  return (
    <Box key={item.type}>
      <Flex gap="medium" alignItems="center">
        <Text width="140px">{label}</Text>
        <Flex gap="medium" alignItems="center">
          <Select
            borderColor="pale_gray"
            size="md"
            width="200px"
            onChange={e => {
              onUpdate({
                type: item.type,
                remindBefore: {
                  value: parseInt(e.target.value.split('_')[0]),
                  unit: e.target.value.split(
                    '_'
                  )[1] as ClinicClientNotificationPreferencesDtoAppointmentsItemsItemRemindBeforeUnit
                }
              })
            }}
          >
            {options.map(option => (
              <option
                selected={
                  `${item.remindBefore.value}_${item.remindBefore.unit}` ===
                  `${option.value}_${option.unit}`
                }
                value={`${option.value}_${option.unit}`}
              >
                {option.value} {option.unit} before
              </option>
            ))}
          </Select>
          <Switch
            size="lg"
            isChecked={item.isActive}
            onChange={e => {
              onUpdate({
                type: item.type,
                isActive: e.target.checked
              })
            }}
          />
        </Flex>
      </Flex>
    </Box>
  )
}
